import { Backdrop, CircularProgress } from '@mui/material';
import { FC } from 'react';

export type LoadingProps = {
  open: boolean;
};

const Loading: FC<LoadingProps> = ({ open }: LoadingProps) => {
  return open ? (
    <Backdrop sx={{ color: 'white', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
      <CircularProgress color="inherit" />
    </Backdrop>
  ) : null;
};

export { Loading };
